import { ChangeDetectorRef, Component } from '@angular/core';
import { TealiumAnalyticsEvent, TealiumAnalyticsService } from '@ddt-web/analytics';
import { CellData } from '@ddt-web/data-service';
import { FundsToExploreOptions } from '@ddt-web/domain';
import { ApplicationStateStoreProxyService } from '@ddt-web/shared-stores';
import { UrlService } from '@ddt-web/url';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import * as cloneDeep from 'lodash/cloneDeep';
import * as get from 'lodash/get';
import { combineLatest } from 'rxjs';

@UntilDestroy()
@Component({
	selector: 'ac-lightbulb-cell-renderer',
	templateUrl: './lightbulb-cell-renderer.component.html',
	styleUrls: ['./lightbulb-cell-renderer.component.scss']
})
export class LightbulbCellRendererComponent implements ICellRendererAngularComp {
	public data: CellData;
	public params: any;
	public fteOptions: any;
	public currentFteOptions: Array<FundsToExploreOptions>;
	public currentOption: FundsToExploreOptions;
	public showIcon: boolean = false;
	public hoverText: string;

	constructor(
		private applicationStateStoreProxyService: ApplicationStateStoreProxyService,
		private changeDetection: ChangeDetectorRef,
		private urlService: UrlService,
		private tealiumAnalyticsService: TealiumAnalyticsService
	) { }

	public agInit(params: any): void {
		this.params = params;
		this.data = this.params['value'];
		this.showIcon = this.params.data?.ticker?.rawValue !== this.data.rawValue;
		combineLatest([this.applicationStateStoreProxyService.getFundsToExplore(), this.applicationStateStoreProxyService.getSelectedPortfolioIndex()])
			.pipe(untilDestroyed(this))
			.subscribe(([fteStateOptions, selectedPortfolioIndexState]) => {
				const portfolioIds = this.urlService.getPortfolioIds();
				this.fteOptions = cloneDeep(fteStateOptions.fundsToExplore);
				this.currentFteOptions = get(this.fteOptions, `[${portfolioIds[selectedPortfolioIndexState.selectedPortfolioIndex]}]`, []);
				this.currentOption = this.currentFteOptions.find(
					option => option.fund?.fundSuggestion?.ticker === this.data.rawValue &&
						option.fund?.currentFund.ticker === this.data.attribute.parentTicker ||
						this.data.attribute?.agGridRowIdentifier?.includes(option.fund?.currentFund.ticker)
				);
				this.changeDetection.detectChanges();
			});
	}

	public refresh(): boolean {
		return false;
	}

	public onClickFund(): void {
		this.currentOption.isSelectedInTable = !this.currentOption.isSelectedInTable;
		this.applicationStateStoreProxyService.updateFundsToExplore(this.fteOptions);

		this.sendLightBulbTealiumEvent();
	}

	private sendLightBulbTealiumEvent(): void {
		const eventName = `holdings-characteristics-table:accordion:${this.currentOption.fund.currentFund.ticker}-${this.currentOption.fund.fundSuggestion.ticker}`;
		const event = new TealiumAnalyticsEvent(eventName, {});
		this.tealiumAnalyticsService.trackEventTealium(event);
	}
}
